import React from 'react'
import './FaqFooter.css'

const FaqFooter = () => {
    return (
        <div className="faq-footer">
            <p className='faq-footer--text'>Pagina hecha con <span className="corazon"></span> por <a href='https://www.instagram.com/faqtoff/'>@faqtoff</a></p>
        </div>
    )
}

export default FaqFooter
